import { v4 as uuidv4 } from "uuid";

const GUEST_USER_ID_KEY = "mix_guest_user_id";

/**
 * Get or create a persistent guest user ID
 * This ID is stored in localStorage and reused across sessions
 * to maintain vote history for guest users
 */
export function getOrCreateGuestUserId(): string {
    try {
        // Try to get existing guest user ID
        const existingId = localStorage.getItem(GUEST_USER_ID_KEY);
        if (existingId) {
            return existingId;
        }

        // Generate new UUID for guest user
        const newGuestId = uuidv4();
        localStorage.setItem(GUEST_USER_ID_KEY, newGuestId);
        return newGuestId;
    } catch (error) {
        console.error("Failed to get/create guest user ID:", error);
        // Fallback: generate temporary ID (won't persist)
        return uuidv4();
    }
}

/**
 * Clear guest user ID (useful for testing or reset scenarios)
 */
export function clearGuestUserId(): void {
    try {
        localStorage.removeItem(GUEST_USER_ID_KEY);
    } catch (error) {
        console.error("Failed to clear guest user ID:", error);
    }
}
